import { ENGT_CHAT } from 'js/bot.model';

import { headerCard, setter } from './headerCard.model';
import { HeaderCardTemplate } from './headerCard.template';

export class HeaderCard {
	constructor(props) {
		setter(props);

		this.init();
		this.html = HeaderCardTemplate(headerCard);
		this.initEvents();
	}

	init() {
		setter({
			alignment: ENGT_CHAT.get('config.header_alignment'),
			description: ENGT_CHAT.get('config.header_description'),
			title: ENGT_CHAT.get('config.bot_name'),
			isLaunchScreenEnabled: ENGT_CHAT.get('config.isLaunchScreenEnabled'),
			headerType: ENGT_CHAT.get('config.headerType'),
		});
	}

	initEvents() {
		ENGT_CHAT.set('onHeaderBackClick', this.onHeaderBackClick);
	}

	async onHeaderBackClick() {
		ENGT_CHAT.get('showLaunchScreen')();
	}

	render() {
		return this.html;
	}
}
